import { create } from "zustand";
import { apiFetch } from "@/lib/api";

export interface DashboardSummary {
  metrics: {
    contacts: number;
    activeChats: number;
    orders: number;
    pendingOrders: number;
    revenue: number;
    campaigns: number;
    groups: number;
    channels: number;
  };
  contactCategories: {
    family: number;
    friend: number;
    business: number;
    vip: number;
    other: number;
  };
  recentActivity: DashboardActivity[];
}

export interface DashboardActivity {
  id: string;
  type: "contact" | "order" | "campaign" | "message";
  title: string;
  titleAm: string;
  subtitle: string;
  subtitleAm: string;
  createdAt: string;
}

interface DashboardState {
  summary: DashboardSummary | null;
  isLoading: boolean;
  error: string | null;
}

interface DashboardActions {
  fetchSummary: () => Promise<void>;
  clearError: () => void;
}

export const useDashboardStore = create<DashboardState & DashboardActions>((set) => ({
  summary: null,
  isLoading: false,
  error: null,

  fetchSummary: async () => {
    set({ isLoading: true, error: null });
    try {
      const summary = await apiFetch<DashboardSummary>("/api/dashboard");
      set({ summary, isLoading: false });
    } catch (error) {
      const message = error instanceof Error ? error.message : "Failed to load dashboard";
      set({ error: message, isLoading: false });
    }
  },

  clearError: () => set({ error: null }),
}));
